import React from 'react';

import { ContainerStyled } from './TreeNavigationButton.styled';

type Props = {
  children: React.ReactNode;
  iconBefore?: React.ReactNode;
  actions?: React.ReactNode;
  onClick: () => void;
  isHighlighted?: boolean;
  isDraggingOver?: boolean;
  isDisabled?: boolean;
  innerRef?: React.Ref<HTMLDivElement>;
};

export function TreeNavigationButton({
  iconBefore,
  actions,
  children,
  ...rest
}: Props): JSX.Element {
  return (
    <ContainerStyled role='button' {...rest}>
      {iconBefore}
      {children}
      {actions}
    </ContainerStyled>
  );
}
